import { useState, useCallback } from 'react';
import { accountService } from '@/features/card/services/accountService/accountService';
import { UpdateLimitRequest } from '@/features/card/types/account.types';
import { useSpinner } from '@chikara/ui';
import { t } from '@/i18n';

export const useUpdateAccountLimit = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);

    const updateLimit = useCallback(async (request: UpdateLimitRequest): Promise<boolean> => {
        show();
        setError(null);
        try {
            await accountService.updateLimit(request);
            return true;
        } catch (err) {
            setError(t('dashboard.card.detail.modals.manageLimit.errors.generic'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide]);

    return {
        updateLimit,
        isLoading: isSpinnerLoading,
        error
    };
};
